import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_OrderController_ValidateCreateBody_Input_OwnerType,
  useOrderValidateMutation,
} from 'api/generated/graphql';
import { parseValidateOrderParams, useError } from 'api/helpers';
import { ValidateOrderParams } from 'api/types/params';

export const useValidateOrder = () => {
  const [validateOrder, { loading, error: apolloError }] =
    useOrderValidateMutation();

  const error = useError(apolloError);

  return {
    validateOrder: useCallback(
      async (
        ownerId: string,
        ownerType: 'Client' | 'LegalClient',
        params: ValidateOrderParams
      ) => {
        const input = parseValidateOrderParams(params);
        const res = await validateOrder({
          variables: {
            input: {
              ownerId,
              ownerType:
                MutationInput_OrderController_ValidateCreateBody_Input_OwnerType[
                  ownerType
                ],
              ...input,
            },
          },
        });

        return !!res.data?.orderValidate;
      },
      [validateOrder]
    ),
    error,
    loading,
  };
};
